
export default {
  layoutProps: {
    titleToken: "contacts.title",
  },

  data: () => ({
    items: [
      {
        photo: { url: "/img/contacts/bauer.jpg" },
        firstName: { ru: "Елена", en: "Elena" },
        lastName: { ru: "Бауэр", en: "Bauer" },
        position: { ru: "Программа", en: "Program" },
        email: "EBauer@sk.ru",
      },
      {
        photo: { url: "/img/contacts/butynina.png" },
        firstName: { ru: "Наталия", en: "Natalia" },
        lastName: { ru: "Бутынина", en: "Butynina" },
        position: { ru: "Спикеры", en: "Speakers" },
        email: "speaker@sk.ru",
      },
      {
        photo: { url: "/img/contacts/gavrikova.jpg" },
        firstName: { ru: "Ирина", en: "Irina" },
        lastName: { ru: "Гаврикова", en: "Gavrikova" },
        position: { ru: "Участники", en: "Participants" },
        email: "IGavrikova@sk.ru",
      },
      {
        photo: { url: "/img/contacts/shekoyan.png" },
        firstName: { ru: "Михаил", en: "Mikhail" },
        lastName: { ru: "Шекоян", en: "Shekoyan" },
        position: { ru: "СМИ", en: "Mass media" },
        email: "MShekoyan@sk.ru",
      },
      // {
      //      photo: { url: "/img/contacts/openysheva.jpg" },
      //      firstName: { ru: "Наталья", en: "Natalia" },
      //      lastName: { ru: "Опенышева", en: "Openysheva" },
      //      position: { ru: "Выставка Startup Bazaar", en: "Exhibition Startup Bazaar" },
      //      email: "bazaar@startupvillage.ru",
      //    },
      //    {
      //      photo: { url: "/img/contacts/sakhno.jpg" },
      //      firstName: { ru: "Кристина", en: "Kristina" },
      //      lastName: { ru: "Сахно", en: "Sakhno" },
      //      position: { ru: "Digital Marketing", en: "Digital Marketing" },
      //      email: "KSakhno@sk.ru",
      //    },
      //    {
      //      photo: { url: "/img/contacts/sosin.jpg" },
      //      firstName: { ru: "Максим", en: "Maksim" },
      //      lastName: { ru: "Сосин", en: "Sosin" },
      //      position: { ru: "Партнеры", en: "Partners" },
      //      email: "partners@sk.ru",
      //    },
      //    {
      //      photo: { url: "/img/contacts/butynina.png" },
      //      firstName: { ru: "Наталия", en: "Natalia" },
      //      lastName: { ru: "Бутынина", en: "Butynina" },
      //      position: { ru: "Конкурс CreativeTECH", en: "CreativeTECH contest" },
      //      email: "NButynina@sk.ru",
      //    },
    ],
  }),
}
